import React, { useEffect, useRef, useState } from 'react'
import TypewriterDev from './TypewriterDev';
import TypewriterEffect from './TypewriterEffect';
import {motion} from 'framer-motion';

const NavBar = ({deviceMobile, scrollPosition, actives}) => {
 

  let colorBackNav = '';
  let colorNav = ''

  const [clickToggle, setClickToggle] = useState(false);

  if(deviceMobile && clickToggle){
    colorBackNav =  'colorSecundary';
    colorNav = ' navbar-light '
  }else {
    colorBackNav =  scrollPosition < 100 ? '' : 'colorSecundary';
    colorNav = scrollPosition < 100 ? 'navbar-dark ' : 'navbar-light '
  }
  
  const activeAbout = actives.activeAbout ? 'active' : '' ;
  const activeServices = actives.activeServices ? 'active' : '' ;
  const activePortfolio = actives.activePortfolio ? 'active' : '' ;
  const activeStack = actives.activeStack ? 'active' : '' ;
  const activeContact = actives.activeContact ? 'active' : '' ;

  const classNavEffect = deviceMobile ? '' : 'classNavEffect';
  const heightNav = clickToggle? '300' : '0'
  const toogleButtonRef = useRef();

  //imagen de perfil
  const [profilePictureUrl, setProfilePictureUrl] = useState("/assets/rostro-perfil.jpg")
  const [profilePictureName, setProfilePictureName] = useState('profile photo')
  
  const handleClickToggle = () => {
    setClickToggle(!clickToggle);
  }

  const clickSocialNetwork = (URL) => {
    const win = window.open(URL, '_blank');
    win.focus();
  }

const pressToggle = () => {
  if(deviceMobile) toogleButtonRef.current.click();
}

  const socialNetworks = {
      github: 'https://github.com/raffgut/',
      linkedin: 'https://co.linkedin.com/in/raffgut/'
  }



  return (
    
    <motion.div animate={{ x: 0 }} initial={{x: 100}}
    transition={{ ease: "easeOut", duration: 0.5 }}>
          <nav style={{paddingBottom: heightNav + 'px', transition: 'all 400ms ease'}} className= {"navbar navbar-expand-lg fixed-top pt-4 " + colorNav + colorBackNav} id="navbar-spyheader">
             
              <div className="container container-fluid px-4 px-lg-5">
                  <div className='perfil-data hover-perfil'>
                  <img
                      alt={profilePictureName}
                      className="rounded-circle"
                      style={{ width: "4.8rem", maxHeight:'4.8rem', marginBottom:'15px'}}
                      src={profilePictureUrl}
                    />
                    <div style={{paddingBottom: '13px', paddingLeft: '5px'}}>
                 
                      <a className="navbar-brand" style={{marginRight: '0px'}} href="#page-top"><TypewriterEffect /></a>
                      <p className="navbar-brand" style={{fontSize: '12px', paddingTop: '0px', marginBottom:'0px'}}><TypewriterDev /></p>
                      <i title='Github' className = "fab fa-github social-network" onClick={() => clickSocialNetwork(socialNetworks.github)}></i> <i title='Linkedin' className = "fab fa-linkedin social-network" onClick={() => clickSocialNetwork(socialNetworks.linkedin)}></i>
                    </div>
                  </div>
                  <button className="navbar-toggler" ref={toogleButtonRef} onClick={handleClickToggle} type="button" data-bs-toggle="collapse" data-bs-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation"><span className="navbar-toggler-icon" ></span></button>
                  <div className="collapse navbar-collapse" id="navbarResponsive">
                      <ul className={"navbar-nav ms-auto my-2 my-lg-0 " + classNavEffect}>
                          <li className="nav-item"> <a  href='#about' className={"nav-link "+ activeAbout} onClick={pressToggle} >About</a></li>
                          <li className="nav-item"> <a href='#services' className={"nav-link "+ activeServices} onClick={pressToggle}>Servicios</a></li>
                          <li className="nav-item"> <a href='#portfolio' className={"nav-link "+ activePortfolio}onClick={pressToggle} >Portafolio</a></li>
                          <li className="nav-item"> <a href='#stack' className={"nav-link "+ activeStack} onClick={pressToggle}>Stack</a></li>
                          <li className="nav-item"> <a href='#contact' className={"nav-link "+ activeContact} onClick={pressToggle}>Contacto</a></li>
                      </ul>
                  </div>
              </div>
          </nav>


    </motion.div>
  )
}

export default NavBar
